import { render, staticRenderFns } from "./note-modal.vue?vue&type=template&id=55bb9c8f&"
import script from "./note-modal.vue?vue&type=script&lang=js&"
export * from "./note-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports